import { Env } from './util.js';
import appAuthorization from './appAuth.js';
import wxAuthorization from './wxAuth.js';

let cg = Env.isCGApp();
let isWeixin = Env.isWeixin();
console.log('客户端：',cg);
console.log('微信：', isWeixin);
let Authorization = '', auth = '';

// if(Env.isCGApp()){
//   // 客户端授权
//   Authorization = new appAuthorization('cbgcAuth');
// }
Authorization = new appAuthorization('cbgcAuth');
if(Env.isWeixin()){
  // 微信网页授权
  Authorization = new wxAuthorization('cbgcAuth');
}
if(!Env.isCGApp() && !Env.isWeixin()){
  var customUserAgent = 'Mozilla/5.0 (Linux; Android 10; ALP-AL00 Build/HUAWEIALP-AL00; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/79.0.3945.116 Mobile Safari/537.36 TheCover/7.0.0 (TheCover_7.0.0_android_ffffffff-c3df-abb4-ffff-ffffefeffe6f-AFGS)';
  // var customUserAgent = ' Mozilla/5.0 (Linux; Android 8.0.0; MI 6 Build/OPR1.170623.027; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/62.0.3202.84 Mobile Safari/537.36 TheCover/4.5.0 (TheCover_4.5.0_android_867391030611185_appname)';
  Object.defineProperty(navigator, 'userAgent',{
    value: customUserAgent,
    writable: false
  });
}
auth = function(params){
  return new Promise((resolve, reject) => {
    Authorization ? (Authorization.Auth(params).then(res=>{
      // console.log('auth res:' ,res);
      resolve(res);
    }).catch(err=>reject(err))) : resolve({
      status: 'validEnv',
      message: '请在客户端或者微信操作'
    });
  });
}

export default auth;
